import React, { Component } from 'react';
import MainHeader from '../../../components/common/MainHeader';
import FooterDesktop from '../../../components/common/FooterDesktop_bhutan';
import BangkokPattaya_8N_9D_Chennai_Package from '../../../components/package/Thailand/BangkokPattaya_8N_9D_Chennai_Package';
import { Helmet } from 'react-helmet';
class BangkokPattaya_8N_9D_Chennai_Page extends Component {
    constructor() {
        super();
        this.state = {
            HotPackagesData: [],
            ReviewersData: [],

        }
    }


    componentDidMount() {

        window.scroll(0, 0);
        const hotPackageDataList = [
            {
                Title: "Bangkok Tour Package",
                ImageName: "bangkok-pattaya-tour-1.webp",
                AllternateText: "Bangkok Tour Package",
                Description: "2N Bangkok | 2N Pattaya",
                PricePerNight: "18,199",
                Url: 'tel:+919163676037',
         
            },
            {
                Title: "Thailand Honeymoon Trip",
                ImageName: "bangkok-pattaya-tour-2.webp",
                AllternateText: "Thailand Honeymoon Trip",
                Description: "2N Phuket | 2N Krabi",
                PricePerNight: "21,499",
                Url: 'tel:+919163676037',

            },
            {
                Title: "Thailand Deluxe Trip",
                ImageName: "bangkok-pattaya-tour-3.webp",
                AllternateText: "Thailand Deluxe Trip",
                Description: "2N Phuket | 2N Krabi | 2N Bangkok | 2N Pattaya",
                PricePerNight: "36,199",
                Url: 'tel:+919163676037',
            },
            {
                Title: "Pattaya Vacation",
                ImageName: "bangkok-pattaya-tour-4.webp",
                AllternateText: "Pattaya Vacation",
                Description: "3N Pattaya",
                PricePerNight: "12,199",
                Url: 'tel:+919163676037',
            },
            {
                Title: "Bangkok & Phuket Tour",
                ImageName: "bangkok-pattaya-tour-5.webp",
                AllternateText: "Bangkok & Phuket Trip",
                Description: "2N Phuket | 2N Bangkok",
                PricePerNight: "18,750",
                Url: 'tel:+919163676037',
            },
	    {
                Title: "Bangkok & Krabi Trip",
                ImageName: "bangkok-pattaya-tour-6.webp",
                AllternateText: "Bangkok & Krabi Trip",
                Description: "2N Krabi | 2N Bangkok",
                PricePerNight: "18,499",
                Url: 'tel:+919163676037',
            }

        ];



        const reviewersDataList = [
            {
                Name: "Upama Roy",
                ImageName: "Upama-Roy-Mehta.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "We always travel with Adorable Vacation. This time we went for a 6 days trip to Bangkok, Phuket and Krabi. As usual the trip was very well planned. Everybody was always ready to help. Great hotels, great hospitality. Really had fun in the trip.Looking forward to travel again with Adorable Vacation team in our next holiday.",
            },
            {
                Name: "Sourav Das",
                ImageName: "Sourav-Das.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "Good Hotels, Good Food, Good Location — everything came together perfectly for a truly memorable tour to Thailand. From start to finish, the arrangements were seamless and well-coordinated. The accommodations were comfortable and conveniently located, the meals were delicious and catered to our tastes, and the itinerary was thoughtfully planned to ensure we experienced the best of Thailand without feeling rushed.",
            },
            {
                Name: "Ruchir Mehta",
                ImageName: "RUCHIR-MEHTA.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "We had an amazing 8-night, 9-day family tour of Thailand with Adorable Vacation LLP! From the bustling streets of Bangkok to the serene beaches of Pattaya, every moment was perfectly organized and hassle-free. The accommodations were luxurious, the itinerary well-balanced, and the local experiences unforgettable. Highlights included the vibrant markets, breathtaking temples, and delightful Thai cuisine. Our driver knowledgeable and friendly, making our trip even more enjoyable. We couldn't have asked for a better family vacation!",
            },
            {
                Name: "Shalini Paul",
                ImageName: "Shalini-Paul.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "Thanks this wonderful team for organising my honeymoon trip to Thailand with ease They regularly followed up weather we had any problems or not Kudos to the team for their good work.",
            },
        ];

        this.setState({
            HotPackagesData: hotPackageDataList,
            ReviewersData: reviewersDataList
        })
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Bangkok Pattaya Package Tour from Chennai, Bangkok Pattaya Tour Package from Chennai</title>
                    <meta name="description" content=" We Offer the Best Bangkok Pattaya package tour from Chennai with Best Price. For Booking ☎ CALL Mr. AKASH +91-91636-76037" />
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "http://schema.org",
                            "@type": "Product",
                            "name": "Bangkok Pattaya Tour From Chennai Reviews",
                            "aggregateRating": {
                                "@type": "AggregateRating",
                                "ratingValue": "4.9",
                                "bestRating": "5",
                                "ratingCount": "475"
                            }
                        })}
                    </script>
                </Helmet>

                <MainHeader />

                <BangkokPattaya_8N_9D_Chennai_Package
                    HotPackagesData={this.state.HotPackagesData}
                    ReviewersData={this.state.ReviewersData}
                />

                <FooterDesktop />
            </>
        )
    }
}

export default BangkokPattaya_8N_9D_Chennai_Page;